import React, { useEffect, useState } from "react";
import { getClientAPI } from "../service/UserService";
import { getUsersWithUserTypeAPI } from "../service/UserService";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { updateCommissionAPI, updateUserStatusAPI, sendLoginDetailsAPI, unSettledBetsAPI, getCollectionReportAPI } from "../service/AuthService";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import Loader from "./components/Loader";
import SendLoginDetails from "./components/SendLoginDetails";
import store from "../redux/store";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { PERMISSION_MAP_CLIENT } from "../utils/constants";



export default function MyClients() {
  const [showSendLoginDetails, setShowSendLoginDetails] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = useState("");
  const [userTypeName, setUserType] = useState('');
  const [clientData, setClientData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [userTypeList, setGetUsersWithUsers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setSize] = useState(50);
  const [userId, setGetUserId] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const { userType, userName } = useParams();
  const location = useLocation();
  const [isActive, setIsActive] = useState(null);
  const userData = store.getState().account.userData;
  const [id, setId] = useState(location?.state?.userName || "");

  const getUsersWithUserType = async () => {
    let userTypeGet;
    if (userType?.toUpperCase() === "SUPER_ADMIN") {
      userTypeGet = 'SUPER_ADMIN';
    }
    if (userType?.toUpperCase() === "SUB_ADMIN") {
      userTypeGet = 'ADMIN';
    } else if (userType?.toUpperCase() === "MASTER") {
      userTypeGet = 'SUB_ADMIN';
    }
    else if (userType?.toUpperCase() === "SUPER_AGENT") {
      userTypeGet = 'MASTER';
    }
    else if (userType?.toUpperCase() === "AGENT") {
      userTypeGet = 'SUPER_AGENT';
    }
    else if (userType?.toUpperCase() === "CLIENT") {
      userTypeGet = 'AGENT';
    }
    setLoading(true);
    setUserType(userTypeGet);
    const { response } = await getUsersWithUserTypeAPI(userTypeGet);
    let response_ = response;
    if (response_) {
      setLoading(false);
      setGetUsersWithUsers(response_)
      setGetUsersWithUsers(response_)

    }
    else {
      setLoading(false);
    }
  };
  const handleActiveInactive = async (userData) => {
    const { response, code } = await updateUserStatusAPI(userData?.uid, !userData?.isActive, userData?.isBetLocked);
    if (code == 200) {
      getClient()
      toast.success(`User status changed`)
    }
  }
  const getClient = async (search) => {
    setLoading(true)
    const { response } = await getClientAPI(
      search = search,
      currentPage,
      size,
      id,
      userName ? "" : userType?.toUpperCase(),
      location?.state?.blocked,
      isActive != null ? isActive : null,
      userName
    );
    let response_ = response;
    if (response_) {
      response_.childrenUserResponseDTOS = response_.childrenUserResponseDTOSPage.content.sort(
        (a, b) => a.uid - b.uid
      );
      setCurrentPage(response_.childrenUserResponseDTOSPage.number);
      setTotalPages(response_.childrenUserResponseDTOSPage.totalPages);
      setTotalElements(response_.childrenUserResponseDTOSPage.totalElements);
      setSize(response_.childrenUserResponseDTOSPage.size);
    }
    setLoading(false)
    setClientData(response_);
  };

  const navigate = useNavigate();
  useEffect(() => {
    getClient();
    getUsersWithUserType();
  }, [location.state, location.search, location.pathname, size,
    currentPage,]);

  const handleSelectChangeUser = (selectedOptions) => {
    const userIds = selectedOptions?.value;
    console.log(selectedOptions)
    setGetUserId(userIds);
    setSelectedUsers(selectedOptions);
  };
  // table 

  const [expandedRow, setExpandedRow] = useState(null);
  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };


  const shareDetails = async (client) => {
    const { response, code } = await sendLoginDetailsAPI(client?.uid);
    if (code == 200) {
      setShowSendLoginDetails({
        username: client?.username,
        password: response?.password,
        userType: client?.userType,
      });
    } else {
      toast.error(response);
    }
  };

  const ROLE_HIERARCHY = {
    SUPER_ADMIN: "ADMIN",
    ADMIN: "SUB_ADMIN",
    SUB_ADMIN: "MASTER",
    MASTER: "SUPER_AGENT",
    SUPER_AGENT: "AGENT",
    AGENT: "CLIENT",
  };

  const handleNewClick = () => {
    const users = userTypeList?.users ?? [];
    if (!users.length) return;

    const loggedInRole = userData?.userType?.toUpperCase();
    const creatingRole = userType?.toUpperCase();

    const autoCreateRole = ROLE_HIERARCHY[loggedInRole];

    // ✅ CONDITION 1:
    // If creating immediate lower role → auto select logged-in user
    if (autoCreateRole === creatingRole) {
      const firstUser = users[0]; // parent user

      const selectedUserData = {
        value: firstUser.userId,
        label: `${firstUser.userName} ${firstUser.name}`,
      };

      setGetUserId(firstUser.userId);
      setSelectedUsers(selectedUserData);

      navigate(`/create/new/${userType}`, {
        state: {
          userId: firstUser.userId,
          selectedUsers: selectedUserData,
        },
      });
      return;
    }

    // ✅ CONDITION 2:
    // If only ONE user & same role → auto select
    const sameUserType =
      creatingRole === loggedInRole;

    if (users.length === 1 && sameUserType) {
      const firstUser = users[0];
      const selectedUserData = {
        value: firstUser.userId,
        label: `${firstUser.userName} ${firstUser.name}`,
      };
      setGetUserId(firstUser.userId);
      setSelectedUsers(selectedUserData);
      navigate(`/create/new/${userType}`, {
        state: {
          userId: firstUser.userId,
          selectedUsers: selectedUserData,
        },
      });
      return;
    }
    // ✅ OTHERWISE → show modal
    const modalEl = document.getElementById("modal-default");
    if (modalEl && window.bootstrap?.Modal) {
      const modal = new window.bootstrap.Modal(modalEl);
      modal.show();
    }
  };

  const [userUnsettledBets, setUserUnsettledBets] = useState(false);
  const getUnsettledBetByUsername = async (username) => {
    console.log(username)
    setLoading(true);
    const {
      response: { content },
    } = await unSettledBetsAPI({
      pageSize: 1000,
      pageNumber: 0,
      betStatus: "MATCHED",
    });
    setLoading(false);
    setUserUnsettledBets(
      content?.filter((item) => item.userName?.split(" ")[0] == username)
    );
  };


  return (
    <>
      {showSendLoginDetails && (
        <SendLoginDetails
          show={showSendLoginDetails}
          setShow={setShowSendLoginDetails}
        />
      )}

      {userUnsettledBets && (
        <Modal className="sitemoadal "
          show={userUnsettledBets}
          onHide={() => setUserUnsettledBets(false)}
        >
          <Modal.Header>
            <Modal.Title className="" style={{ color: '#6610f2' }}>Unsettled Bets</Modal.Title>
            <button
              type="button"
              className="btn-close btn-close-1"
              aria-label="Close"
              onClick={() => setUserUnsettledBets(false)}
            >
              Close
            </button>
          </Modal.Header>
          <Modal.Body className="modal-lg">
            <div className="custom_table">
              <div className="table-responsive height-500">
                <table className="table">
                  <thead className="ant-table-thead">
                    <tr>
                      <th className="textoftable">SNo</th>
                      <th className="textoftable">Event Name</th>
                      <th className="textoftable">Runner Name</th>
                      <th className="textoftable">Rate</th>
                      <th className="textoftable">Run</th>
                      <th className="textoftable">Mode</th>
                      <th className="textoftable">Amount</th>
                      <th className="textoftable">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userUnsettledBets.map((bet, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{bet.event_name}</td>
                        <td>{bet.runner_name}</td>
                        <td>{bet.back_rate || bet?.lay_rate}</td>
                        <td> {bet?.marketName !== 'BOOKMAKER_ODDS_1' ? (bet.back_run || bet.lay_run) : '-'}</td>
                        <td>
                          {bet?.marketName == "BOOKMAKER_ODDS_1"
                            ? bet?.back_rate
                              ? "LAGAI"
                              : "KHAI"
                            : bet?.back_rate
                              ? "YES"
                              : "NO"}
                        </td>
                        <td>{bet.amount}</td>
                        <td>
                          <span style={{ whiteSpace: 'nowrap' }}>
                            {moment(bet?.created_date + "Z").format(
                              "DD-MM-YYYY hh:mm A"
                            )}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}

      <div className="content-wrapper">

        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 style={{ textTransform: 'capitalize' }}>{userType?.toLocaleLowerCase()}</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">{userType?.toLocaleLowerCase()}</li>
                </ol>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                {/* /.card */}
                <div className="card">
                  <div className="card-header border-none p-1">
                    <div className="form-group d-flex wrap" style={{ gap: "5px" }}>
                      {userType?.toLowerCase() === 'admin' ? (
                        <Link
                          to={`/create/new/${userType}`}
                          type="button"
                          className="btn btn-primary"
                        >
                          New <i className="fa fa-plus-circle" />
                        </Link>
                      ) : (
                        <button
                          className="btn btn-primary"
                          type="button"
                          onClick={handleNewClick}
                        >
                          New <i className="fa fa-plus-circle" aria-hidden="true" />
                        </button>
                      )}
                      <button
                        className="btn btn-success"
                        id="allActive"
                        type="submit"
                        name="check"
                        value={1}
                      >
                        All Active
                      </button>
                      <button
                        className="btn btn-danger"
                        id="allInActive"
                        type="submit"
                        name="check"
                        value={0}
                      >
                        All Deactive <i className="fa fa-ban" />
                      </button>
                      {/* {userType?.toUpperCase() !== "CLIENT" ? <> */}
                      {PERMISSION_MAP_CLIENT[userData?.userType?.toUpperCase()] === userType?.toUpperCase() && (
                        <Link
                          to={`/update_limit/${userType}`}
                          type="button"
                          className="btn btn-primary"
                        >
                          Limit Update
                        </Link>
                      )}
                      {/* </> : null} */}
                    </div>
                  </div>
                  <div className="card-body">
                    {/* /.card-header */}
                    {loading ?
                      <Loader isLoading={loading} /> :
                      <div className="">
                        <div
                          className="dataTables_wrapper dt-bootstrap4 no-footer"
                        >
                          <div className="row">
                            <div className="col-sm-12 col-md-6" />
                            <div className="col-sm-12 col-md-6">
                              <div
                                id="example1_filter"
                                className="dataTables_filter"
                              >
                                <div
                                  id="example1_filter"
                                  className="dataTables_filter "
                                >
                                  <label className="d-flex align-items-center justify-content-end"
                                    style={{ gap: '5px' }}
                                  >
                                    {/* Search: */}
                                    <input
                                      type="search"
                                      onChange={(e) => { setSearch(e.target.value) }}
                                      className="form-control form-control-sm"
                                      placeholder=""
                                      value={search}
                                      aria-controls="example1"
                                    />
                                    <span style={{ height: '31px' }}
                                      onClick={() => getClient(search)}
                                      className="btn btn-primary px-2 d-flex justify-content-center align-items-center rounded cursor-pointer">Search</span>
                                    <span style={{ height: '31px' }}
                                      onClick={() => { setSearch(''); getClient(null) }}
                                      className="btn btn-danger px-2 d-flex justify-content-center align-items-center rounded cursor-pointer">Reset</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 table-design">
                              {userType == "client" ? (
                                <table id="example1" className="table  table-bordered table-striped">
                                  <thead>
                                    <tr role="row">
                                      {/* ➕ MOBILE EXPAND COLUMN */}
                                      <th className="d-md-none"></th>

                                      <th className="sorting_disabled" style={{ width: 43 }}>#</th>
                                      <th className="sorting_disabled">CODE</th>
                                      <th className="sorting_disabled">Name</th>
                                      <th className="sorting_disabled sorting_disabled d-none d-md-table-cell">Agent</th>

                                      {/* DESKTOP ONLY */}
                                      <th className="sorting_disabled d-none d-md-table-cell">Mobile</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Password</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Limit</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Share</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Used Limit</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Match</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Session</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Charge</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Status</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {clientData?.childrenUserResponseDTOS?.map((client, index) => (
                                      <React.Fragment key={index}>
                                        {/* ================= MAIN ROW ================= */}
                                        <tr role="row" className="odd">
                                          <td className="d-md-none text-center">
                                            <button
                                              type="button"
                                              onClick={() => toggleRow(index)}
                                              className="btn-plus-table" style={{ backgroundColor: expandedRow === index ? '#d33333' : '#0275d8' }}>
                                              {expandedRow === index ? "−" : "+"}
                                            </button>
                                          </td>

                                          <td>{index + 1}


                                            &nbsp;&nbsp;&nbsp;

                                            {/* YOUR DROPDOWN – NOT TOUCHED */}
                                            <div className="btn-group d-md-inline-flex client-drop">
                                              <button
                                                type="button"
                                                className="btn btn-xs btn-outline-secondary dropdown-toggle dropdown-hover dropdown-icon"
                                                data-toggle="dropdown"
                                              >
                                                <span className="sr-only">Toggle Dropdown</span>
                                              </button>

                                              <div className="dropdown-menu">
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    navigate(`/${userType}/edit/${client.uid}`, {
                                                      state: { client },
                                                    })
                                                  }
                                                >
                                                  Edit
                                                </a>

                                                <a
                                                  className="dropdown-item"
                                                  onClick={() => handleActiveInactive(client)}
                                                >
                                                  {client?.isActive ? "InActive" : "Active"}
                                                </a>
                                                <a
                                                  _ngcontent-ng-c3771564327=""
                                                  className="dropdown-item"
                                                  onClick={() => {
                                                    navigate(
                                                      "/report/account_statement/" +
                                                      client?.uid,
                                                      {
                                                        state: {
                                                          ...client,
                                                          userName: client.username,
                                                        },
                                                      }
                                                    );
                                                  }}
                                                >
                                                  Statement
                                                </a>
                                                <a
                                                  _ngcontent-ng-c3771564327=""
                                                  className="dropdown-item"
                                                  onClick={() => {
                                                    navigate(
                                                      "/report/account_opration/" +
                                                      client?.uid,
                                                      {
                                                        state: {
                                                          ...client,
                                                          userName: client.username,
                                                        },
                                                      }
                                                    );
                                                  }}
                                                >
                                                  Account Operation
                                                </a>
                                                <a
                                                  _ngcontent-ng-c3771564327=""
                                                  className="dropdown-item"
                                                  onClick={() => {
                                                    navigate(`/report/login/${client.userType}`, {
                                                      state: client,
                                                    })
                                                  }}
                                                >
                                                  Login Report
                                                </a>

                                                <a href="javascript:void(0);" className="dropdown-item"
                                                  onClick={() => {
                                                    shareDetails(client);
                                                  }}>
                                                  Send Login Details (Whatshapp)
                                                </a>
                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <a href="#">
                                              {client.username}
                                            </a>
                                          </td>
                                          <td>{client.name}</td>
                                          <td className="d-none d-md-table-cell">{client.parentUserName}</td>
                                          {/* DESKTOP ONLY COLUMNS */}
                                          <td className="d-none d-md-table-cell">{client?.mobile}</td>
                                          <td className="d-none d-md-table-cell">{client.password}</td>
                                          <td className="d-none d-md-table-cell"> {client.balance?.toFixed(2)}</td>
                                          <td className="d-none d-md-table-cell">{client.myPartnership}</td>
                                          <td className="d-none d-md-table-cell"
                                            onClick={() => {
                                              userType?.toUpperCase() == "CLIENT" && getUnsettledBetByUsername(client?.username);
                                            }}>

                                            <span style={{ color: 'blue' }}>{Math.abs(client?.liability?.toFixed(2))}</span>
                                          </td>
                                          <td className="d-none d-md-table-cell">
                                            {client.matchCommission}
                                          </td>
                                          <td className="d-none d-md-table-cell">
                                            {client.sessionCommission}
                                          </td>
                                          <td className="d-none d-md-table-cell">100</td>
                                          <td className="d-none d-md-table-cell">
                                            {client.isActive ? (
                                              <span className="badge bg-success">Active</span>
                                            ) : (
                                              <span className="badge bg-danger">Deactive</span>
                                            )}
                                          </td>
                                        </tr>

                                        {/* ================= EXPANDED ROW (MOBILE ONLY) ================= */}
                                        {expandedRow === index && (
                                          <tr className="d-md-none bg-light">
                                            <td colSpan="13" className="child bg-white">
                                              <ul data-dtr-index={0} className="dtr-details">
                                                <li data-dtr-index={4} data-dt-row={0} data-dt-column={4}>
                                                  <span className="dtr-title">Agent</span>{" "}
                                                  <span className="dtr-data">{client?.parentUserName}</span>
                                                </li>
                                                <li data-dtr-index={5} data-dt-row={0} data-dt-column={5}>
                                                  <span className="dtr-title">Mobile</span>{" "}
                                                  <span className="dtr-data">{client.mobile}</span>
                                                </li>
                                                <li data-dtr-index={6} data-dt-row={0} data-dt-column={6}>
                                                  <span className="dtr-title">Password</span>{" "}
                                                  <span className="dtr-data">{client.password}</span>
                                                </li>
                                                <li data-dtr-index={7} data-dt-row={0} data-dt-column={7}>
                                                  <span className="dtr-title">Limit</span>{" "}
                                                  <span className="dtr-data">{client.balance?.toFixed(2)}</span>
                                                </li>
                                                <li data-dtr-index={7} data-dt-row={0} data-dt-column={7}>
                                                  <span className="dtr-title">Used Limit:</span>{" "}
                                                  <span style={{ color: 'blue' }} className="dtr-data" onClick={() => {
                                                    userType?.toUpperCase() == "CLIENT" && getUnsettledBetByUsername(client?.username);
                                                  }}>{Math.abs(client?.liability?.toFixed(2))}</span>
                                                </li>
                                                <li data-dtr-index={8} data-dt-row={0} data-dt-column={8}>
                                                  <span className="dtr-title">Match</span>{" "}
                                                  <span className="dtr-data">{client.matchCommission}</span>
                                                </li>
                                                <li data-dtr-index={9} data-dt-row={0} data-dt-column={9}>
                                                  <span className="dtr-title">Session</span>{" "}
                                                  <span className="dtr-data">{client.sessionCommission}</span>
                                                </li>
                                                <li data-dtr-index={10} data-dt-row={0} data-dt-column={10}>
                                                  <span className="dtr-title">Share</span>{" "}
                                                  <span className="dtr-data">{client.myPartnership}</span>
                                                </li>
                                                <li data-dtr-index={10} data-dt-row={0} data-dt-column={10}>
                                                  <span className="dtr-title">Charge</span>{" "}
                                                  <span className="dtr-data">{client.myPartnership}</span>
                                                </li>
                                                <li data-dtr-index={11} data-dt-row={0} data-dt-column={11}>
                                                  <span className="dtr-title">Status</span>{" "}
                                                  <span className="dtr-data">
                                                    <div>
                                                      {client.isActive ? (
                                                        <span className="badge bg-success ms-1">Active</span>
                                                      ) : (
                                                        <span className="badge bg-danger ms-1">Deactive</span>
                                                      )}
                                                    </div>
                                                  </span>
                                                </li>
                                              </ul>

                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </tbody>
                                </table>
                              ) : (
                                <table className="table table-bordered table-striped dataTable no-footer dtr-inline">
                                  <thead>
                                    <tr role="row">
                                      <th className="d-md-none"></th>

                                      <th className="sorting_disabled">#</th>
                                      <th className="sorting_disabled">CODE</th>
                                      <th className="sorting_disabled">Name</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Mobile</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Password</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Limit</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Match</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Share</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Session</th>
                                      <th className="sorting_disabled d-none d-md-table-cell">Status</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {clientData?.childrenUserResponseDTOS?.map((client, index) => (
                                      <React.Fragment key={index}>
                                        <tr role="row">
                                          <td className="d-md-none text-center">
                                            <button
                                              type="button"
                                              onClick={() => toggleRow(index)}
                                              className="btn-plus-table" style={{ backgroundColor: expandedRow === index ? '#d33333' : '#0275d8' }}>
                                              {expandedRow === index ? "−" : "+"}
                                            </button>
                                          </td>

                                          <td>
                                            <span className="d-flex gap-1 align-items-center">
                                              <div>
                                                {index + 1}
                                              </div> <div className="btn-group d-none  d-md-inline-flex">
                                                <button
                                                  type="button"
                                                  className="btn btn-xs mobile-resp btn-outline-secondary dropdown-toggle dropdown-hover dropdown-icon"
                                                  data-toggle="dropdown"
                                                >
                                                  <span className="sr-only">Toggle Dropdown</span>
                                                </button>

                                                <div className="dropdown-menu">
                                                  <a
                                                    className="dropdown-item"
                                                    onClick={() =>
                                                      navigate(`/${userType}/edit/${client.uid}`, {
                                                        state: { client },
                                                      })
                                                    }
                                                  >
                                                    Edit
                                                  </a>

                                                  <a
                                                    className="dropdown-item"
                                                    onClick={() => handleActiveInactive(client)}
                                                  >
                                                    {client?.isActive ? "InActive" : "Active"}
                                                  </a>
                                                  <a
                                                    _ngcontent-ng-c3771564327=""
                                                    className="dropdown-item"
                                                    onClick={() => {
                                                      navigate(
                                                        "/report/account_statement/" +
                                                        client?.uid,
                                                        {
                                                          state: {
                                                            ...client,
                                                            userName: client.username,
                                                          },
                                                        }
                                                      );
                                                    }}
                                                  >
                                                    Statement
                                                  </a>
                                                  <a
                                                    _ngcontent-ng-c3771564327=""
                                                    className="dropdown-item"
                                                    onClick={() => {
                                                      navigate(
                                                        "/report/account_opration/" +
                                                        client?.uid,
                                                        {
                                                          state: {
                                                            ...client,
                                                            userName: client.username,
                                                          },
                                                        }
                                                      );
                                                    }}
                                                  >
                                                    Account Operation
                                                  </a>
                                                  <a
                                                  _ngcontent-ng-c3771564327=""
                                                  className="dropdown-item"
                                                  onClick={() => {
                                                    navigate(`/report/login/${client.userType}`, {
                                                      state: client,
                                                    })
                                                  }}
                                                >
                                                  Login Report
                                                </a>

                                                  <a href="javascript:void(0);" className="dropdown-item"
                                                    onClick={() => {
                                                      shareDetails(client);
                                                    }}>
                                                    Send Login Details (Whatshapp)
                                                  </a>
                                                </div>
                                              </div>


                                              {/* </a> */}
                                              &nbsp;&nbsp;&nbsp;
                                              <div className="btn-group">
                                                <button
                                                  type="button"
                                                  className="btn btn-xs btn-outline-secondary dropdown-toggle dropdown-hover dropdown-icon"
                                                  data-toggle="dropdown"
                                                  aria-expanded="false"
                                                >
                                                  <span className="sr-only">Toggle Dropdown</span>
                                                </button>
                                                <div className="dropdown-menu" role="menu" style={{}}>
                                                  <a className="dropdown-item" href="#"
                                                    onClick={() =>
                                                      navigate(`/${userType}/edit/${client.uid}`, {
                                                        state: {
                                                          client,
                                                        },
                                                      })
                                                    }>
                                                    Edit
                                                  </a>
                                                  <span>
                                                    <a className="dropdown-item" onClick={() => {
                                                      handleActiveInactive(client)
                                                    }}>
                                                      {client?.isActive ? "InActive" : "Active"}
                                                    </a>
                                                  </span>

                                                  {userType?.toUpperCase() === "ADMIN" ? (
                                                    <a onClick={() =>
                                                      navigate(`/update/limit/SUB_ADMIN`, {
                                                        state: {
                                                          client,
                                                        },
                                                      })
                                                    } type="button" className="dropdown-item">
                                                      Sub Admin Limit Update
                                                    </a>
                                                  ) : userType?.toUpperCase() === "SUB_ADMIN" ? (
                                                    <a onClick={() =>
                                                      navigate(`/update/limit/MASTER`, {
                                                        state: {
                                                          client,
                                                        },
                                                      })
                                                    } type="button" className="dropdown-item">
                                                      Master Limit Update
                                                    </a>
                                                  ) : userType?.toUpperCase() === "MASTER" ? (
                                                    <a onClick={() =>
                                                      navigate(`/update/limit/SUPER_AGENT`, {
                                                        state: {
                                                          client,
                                                        },
                                                      })
                                                    } type="button" className="dropdown-item">
                                                      Super Agent Limit Update
                                                    </a>
                                                  ) : userType?.toUpperCase() === "SUPER_AGENT" ? (
                                                    <a onClick={() =>
                                                      navigate(`/update/limit/AGENT`, {
                                                        state: {
                                                          client,
                                                        },
                                                      })
                                                    } type="button" className="dropdown-item">
                                                      Agent Limit Update
                                                    </a>) : userType?.toUpperCase() === "AGENT" ? (
                                                      <a onClick={() =>
                                                        navigate(`/update/limit/CLIENT`, {
                                                          state: {
                                                            client,
                                                          },
                                                        })
                                                      } type="button" className="dropdown-item">
                                                        Client Limit Update
                                                      </a>) : null}
                                                  <a
                                                    _ngcontent-ng-c3771564327=""
                                                    className="dropdown-item"
                                                    onClick={() => {
                                                      navigate(
                                                        "/report/account_statement/" +
                                                        client?.uid,
                                                        {
                                                          state: {
                                                            ...client,
                                                            userName: client.username,
                                                          },
                                                        }
                                                      );
                                                    }}
                                                  >
                                                    Statement
                                                  </a>
                                                  <a
                                                    _ngcontent-ng-c3771564327=""
                                                    className="dropdown-item"
                                                    onClick={() => {
                                                      navigate(
                                                        "/report/account_opration/" +
                                                        client?.uid,
                                                        {
                                                          state: {
                                                            ...client,
                                                            userName: client.username,
                                                          },
                                                        }
                                                      );
                                                    }}
                                                  >
                                                    Account Operation
                                                  </a>

                                                  <a
                                                    _ngcontent-ng-c3771564327=""
                                                    className="dropdown-item"
                                                    onClick={() => {
                                                      navigate(`/report/login/${client.userType}`, {
                                                        state: client,
                                                      })
                                                    }}
                                                  >
                                                    Login Report
                                                  </a>


                                                  <a href="javascript:void(0);" className="dropdown-item"
                                                    onClick={() => {
                                                      shareDetails(client);
                                                    }}>
                                                    Send Login Details (Whatshapp)
                                                  </a>

                                                  {/* <a
                                                href="#"
                                                className="dropdown-item"
                                                onclick="sendLoginDetails('C346826','6334206')"
                                              >
                                                Send Login Details (Device)
                                              </a> */}
                                                </div>
                                              </div>
                                            </span>

                                          </td>

                                          <td >
                                            {/* <a
                                            onClick={() => {
                                              navigate(
                                                `/${client?.userType}/children/${client?.username
                                                }`
                                              );
                                            }}
                                          > */}

                                            <span
                                              style={{ color: client?.userType != "CLIENT" ? 'blue' : 'black' }}
                                              onClick={() =>
                                                client?.userType != "CLIENT" &&
                                                navigate(
                                                  `/${PERMISSION_MAP_CLIENT[
                                                  client?.userType
                                                  ]
                                                  }/${client?.username}`
                                                )}
                                            >
                                              {client.username}
                                            </span>



                                          </td>

                                          <td>{client.name}</td>

                                          {/* Desktop only */}
                                          <td className="d-none d-md-table-cell">{client.mobile}</td>
                                          <td className="d-none d-md-table-cell">{client.password}</td>
                                          <td className="d-none d-md-table-cell">
                                            {client.balance?.toFixed(2)}
                                          </td>
                                          <td className="d-none d-md-table-cell">
                                            {client.matchCommission}
                                          </td>
                                          <td className="d-none d-md-table-cell">
                                            {client.myPartnership}
                                          </td>
                                          <td className="d-none d-md-table-cell">
                                            {client.sessionCommission}
                                          </td>
                                          <td className="d-none d-md-table-cell">
                                            {client.isActive ? (
                                              <span className="badge bg-success">Active</span>
                                            ) : (
                                              <span className="badge bg-danger">Deactive</span>
                                            )}
                                          </td>
                                        </tr>

                                        {/* ================= EXPANDED ROW (MOBILE) ================= */}
                                        {expandedRow === index && (
                                          <tr className="d-md-none child">
                                            <td colSpan="11" className="child">
                                              <ul data-dtr-index={0} className="dtr-details">
                                                <li data-dtr-index={4} data-dt-row={0} data-dt-column={4}>
                                                  <span className="dtr-title">{
                                                    userTypeName?.toUpperCase() === "SUPER_AGENT" ? "Super" :
                                                      userTypeName?.toUpperCase() === "SUB_ADMIN" ? "SubAdmin" :
                                                        userTypeName || "SuperAdmin"
                                                  }</span>{" "}
                                                  <span className="dtr-data">{client?.parentUserName}</span>
                                                </li>
                                                <li data-dtr-index={5} data-dt-row={0} data-dt-column={5}>
                                                  <span className="dtr-title">Mobile</span>{" "}
                                                  <span className="dtr-data">{client.mobile}</span>
                                                </li>
                                                <li data-dtr-index={6} data-dt-row={0} data-dt-column={6}>
                                                  <span className="dtr-title">Password</span>{" "}
                                                  <span className="dtr-data">{client.password}</span>
                                                </li>
                                                <li data-dtr-index={7} data-dt-row={0} data-dt-column={7}>
                                                  <span className="dtr-title">Limit</span>{" "}
                                                  <span className="dtr-data">{client.balance?.toFixed(2)}</span>
                                                </li>
                                                <li data-dtr-index={8} data-dt-row={0} data-dt-column={8}>
                                                  <span className="dtr-title">Match</span>{" "}
                                                  <span className="dtr-data"> {client.matchCommission}</span>
                                                </li>
                                                <li data-dtr-index={9} data-dt-row={0} data-dt-column={9}>
                                                  <span className="dtr-title">Session</span>{" "}
                                                  <span className="dtr-data">{client.sessionCommission}</span>
                                                </li>
                                                <li data-dtr-index={10} data-dt-row={0} data-dt-column={10}>
                                                  <span className="dtr-title">Share</span>{" "}
                                                  <span className="dtr-data">{client.myPartnership}</span>
                                                </li>
                                                <li data-dtr-index={11} data-dt-row={0} data-dt-column={11}>
                                                  <span className="dtr-title">Status</span>{" "}
                                                  <span className="dtr-data">
                                                    {client.isActive ? (
                                                      <span className="badge bg-success ms-1">Active</span>
                                                    ) : (
                                                      <span className="badge bg-danger ms-1">Deactive</span>
                                                    )}
                                                  </span>
                                                </li>
                                              </ul>


                                              {/* <ul className="dtr-details">
                                                <li><b>Mobile:</b> {client.mobile}</li>
                                                <li><b>Password:</b> {client.password}</li>
                                                <li><b>Limit:</b> {client.balance?.toFixed(2)}</li>
                                                <li><b>Share:</b> {client.myPartnership}</li>
                                                <li><b>Match:</b> {client.matchCommission}</li>
                                                <li><b>Session:</b> {client.sessionCommission}</li>
                                                <li>
                                                  <b>Status:</b>{" "}
                                                  {client.isActive ? (
                                                    <span className="badge bg-success ms-1">Active</span>
                                                  ) : (
                                                    <span className="badge bg-danger ms-1">Deactive</span>
                                                  )}
                                                </li>
                                              </ul> */}
                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 col-md-5" />
                            <div className="col-sm-12 col-md-7" />
                          </div>
                        </div>
                      </div>
                    }
                    {/* /.card-body */}
                    <div className="row">
                      <div className="col-sm-12 col-md-5">
                        <div
                          className="dataTables_info"
                          id="example1_info"
                          role="status"
                          aria-live="polite"
                        >
                          Showing &nbsp;
                          {currentPage * size + 1} to{" "}
                          {currentPage * size + size > totalElements
                            ? totalElements
                            : currentPage * size + size}{" "}
                          of {totalElements} entries
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-7">
                        <div
                          className="dataTables_paginate paging_simple_numbers"
                          id="example1_paginate"
                        >
                          <ul className="pagination justify-content-end align-items-center">
                            {/* Previous */}
                            <li
                              className={`page-item ${currentPage === 0 ? "disabled" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => {
                                  if (currentPage > 0) {
                                    setCurrentPage(currentPage - 1);
                                  }
                                }}
                                disabled={currentPage === 0}
                              >
                                Previous
                              </button>
                            </li>

                            {/* Current Page */}
                            <li className="page-item active">
                              <span className="page-link">
                                {currentPage + 1} / {totalPages}
                              </span>
                            </li>

                            {/* Next */}
                            <li
                              className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => {
                                  if (currentPage < totalPages - 1) {
                                    setCurrentPage(currentPage + 1);
                                  }
                                }}
                                disabled={currentPage === totalPages - 1}
                              >
                                Next
                              </button>
                            </li>
                          </ul>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card */}
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
        {/* /.content */}
        <section className="content">
          <div className="modal fade" id="modal-default">
            <div className="modal-dialog">
              <form>
                <input type="hidden" name="_method" defaultValue="PUT" />
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">Select {userTypeName}</h4>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <ReactSelect
                      options={userTypeList?.users?.map(user => ({
                        value: user.userId,
                        label: `${user.userName + ` ` + user.name}`,
                      }))}
                      // value={selectedUsers}
                      onChange={handleSelectChangeUser}
                    />

                    {/* <select id="agent" className="form-control"
                    onChange={handleSelectChangeUser}
                  >
                    <option> Please Select</option>
                    {userTypeList?.users?.map((item, index) => (
                      <option value={item.userId}> {item.userName} {item.name}</option>
                    ))}
                  </select> */}
                  </div>
                  <div className="modal-footer justify-content-between">
                    <button
                      type="button"
                      className="btn btn-default"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      data-dismiss="modal"
                      onClick={() => {
                        let userTypeGet = userType;

                        if (userType?.toUpperCase() === "SUPER_ADMIN") {
                          userTypeGet = "ADMIN";
                        }
                        if (userType?.toUpperCase() === "SUB_ADMIN") {
                          userTypeGet = "ADMIN";
                        }

                        navigate(`/create/new/${userType}`, {
                          state: {
                            userId,
                            selectedUsers,
                          },
                        });
                      }}

                      id="Agentpath"
                      type="button"
                      className="btn btn-primary">
                      Continue
                    </button>
                  </div>
                </div>
              </form>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
        </section>
      </div>
    </>
  );
}
